var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13V7C21.5 5.93913 21.0786 4.92178 20.3284 4.17163C19.5783 3.42149 18.5609 3 17.5 3H5.5C4.43913 3 3.42178 3.42149 2.67163 4.17163C1.92149 4.92178 1.5 5.93913 1.5 7V14C1.5 15.0609 1.92149 16.0783 2.67163 16.8285C3.42178 17.5786 4.43913 18 5.5 18H7.5L9.79004 20.29C10.0493 20.5496 10.3638 20.7473 10.7101 20.8685C11.0564 20.9897 11.4255 21.0312 11.79 20.99",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.94 21.88C19.8399 21.88 21.38 20.3399 21.38 18.44C21.38 16.5401 19.8399 15 17.94 15C16.0401 15 14.5 16.5401 14.5 18.44C14.5 20.3399 16.0401 21.88 17.94 21.88Z",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5009 23L20.3809 20.88",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.c9c5172b6579649c51f17669969ecc00.svg";
export { ForwardRef as ReactComponent };